export const URL_GIFT_IMAGE =
  "https://images.hallow.app/assets/gifthallow.webp";
